import Button from '@/components/Button'
import Text from '@/components/Text'
import { useRouter } from 'next/router'
import * as styles from './style'

export interface Props {
  title: string
  messageContent: string
  route?: string
  buttonLabel?: string
}

const EmptyStateCard = ({ title, messageContent, buttonLabel, route }: Props): JSX.Element => {
  const router = useRouter()
  const defaultRoute = `/schedule/browse`

  const handleScheduleRoute = (): void => {
    router.push(route ? route : defaultRoute)
  }

  return (
    <div className={styles.root}>
      <Text size="lg" weight="lg">
        {title}
      </Text>
      <div className={styles.bodyContainer}>
        <Text size="xs" weight="sm" className={styles.content}>
          {messageContent}
        </Text>
        {buttonLabel && <Button onClick={handleScheduleRoute} label={buttonLabel} />}
      </div>
    </div>
  )
}
export default EmptyStateCard
